import { useCombobox, UseComboboxState, UseComboboxStateChangeOptions } from "downshift";
import { BaseOptionType } from "../types";
import { findNextValidOptionIndex } from "../utils";

/**
 * StateReducer for SelectComboBox and MultiSelectComboBox for when highlightFirstOptionAutomatically is true.
 */
export const highlightFirstAutomaticallyStateReducer = <T extends BaseOptionType>(
    options: T[],
    currentState: UseComboboxState<T>,
    actionsAndChanges: UseComboboxStateChangeOptions<T>
) => {
    const { changes, type } = actionsAndChanges;
    switch (type) {
        case useCombobox.stateChangeTypes.FunctionToggleMenu:
            if (!currentState.isOpen && changes.isOpen === true) {
                return {
                    ...changes,
                    highlightedIndex: findNextValidOptionIndex(options),
                };
            }
            break;
        case useCombobox.stateChangeTypes.ToggleButtonClick:
            // if the menu is opening
            if (!currentState.isOpen && changes.isOpen === true) {
                return {
                    ...changes,
                    highlightedIndex: findNextValidOptionIndex(options),
                };
            }
            break;
    }

    return changes;
};
